import React, { useEffect, useRef } from "react";
import { Typography } from "@mui/material";

import rush from "../../assets/images/rush.jpg";
import barlant from "../../assets/images/barlant.jpg";
import zaid from "../../assets/images/zaid.jpg";
import amy from "../../assets/images/amy.jpg";
import samsung from "../../assets/images/samsung.jpg";
import caravan from "../../assets/images/caravan.jpg";

const logos = [
  { src: rush, alt: "Rush" },
  { src: samsung, alt: "Samsung" },
  { src: caravan, alt: "Caravan" },
  { src: zaid, alt: "Zaid" },
  { src: amy, alt: "Amy" },
  { src: barlant, alt: "Barlant" },
];

const HorizontalScroll = () => {
  const marqueeRef = useRef(null);

  // Animate only when visible
  useEffect(() => {
    const el = marqueeRef.current;
    if (!el) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) el.classList.add("is-visible");
          else el.classList.remove("is-visible");
        });
      },
      { rootMargin: "100px" }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <div className="clients-section">
      <div className="clients-title">
        <Typography
          sx={{
            fontFamily: "DM Serif Display, Tajawal, sans-serif",
            fontSize: 25,
            py: 6,
            letterSpacing: "0.15em",
          }}
        >
          CLIENTS
        </Typography>
      </div>

      {/* Marquee */}
      <div
        className="clients-marquee"
        ref={marqueeRef}
        aria-label="Client logos carousel"
        role="region"
      >
        <div className="marquee-track" aria-hidden="false">
          {[...logos, ...logos, ...logos].map((l, i) => (
            <div className="logo-item" key={i}>
              <img
                src={l.src}
                alt={`${l.alt} — client logo`}
                loading="lazy"
                decoding="async"
                width="160"
                height="160"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HorizontalScroll;
